import { rem } from 'polished';
import styled from 'styled-components';
import { iconWrapperStyling } from 'Book/shared/components/UpcomingAppointments/styles';

const sizes = {
  wrapper: {
    padding: 24,
  },
  cancel: {
    padding: 5,
    marginTop: 24,
  },
  divider: {
    height: 1,
  },
};

export const Wrapper = styled.section`
  // Use flex so we can order the cancel button
  display: flex;
  flex-flow: column;

  .success {
    margin-bottom: ${rem(24)};
    border: none;

    span {
      display: inline-block;
    }
  }

  .cancel-button-wrapper,
  .cancel-button {
    width: 100%;
    margin: ${rem(sizes.cancel.marginTop * 2 + sizes.divider.height)} 0 0 0;
    order: 10;
  }

  .cancel-button {
    float: none;
    position: relative;
    padding: ${rem(sizes.cancel.padding)};
    font-size: ${rem(16)};
    opacity: 0.95;

    span {
      display: none;
    }

    &::before {
      content: '';
      width: calc(100% + ${rem(sizes.wrapper.padding * 2)});
      height: ${rem(sizes.divider.height)};
      position: absolute;
      top: -${rem(sizes.cancel.marginTop + sizes.divider.height)};
      left: -${rem(sizes.wrapper.padding)};
      background: ${({ theme }) => theme.colors.text.primary};
      opacity: 0.2;
      display: block;
    }

    &::after {
      content: attr(data-long-text);
      display: inline-block;
    }
  }

  .ds-card {
    margin-top: ${rem(24)};
    padding: ${rem(16)};

    h2 {
      margin: 0 0 ${rem(8)} 0;
      font-size: ${rem(16)};
      font-weight: 600;
    }

    ul {
      margin: 0;
      padding: 0 0 0 ${rem(16)};
    }

    li {
      font-size: ${rem(14)};
      line-height: 140%;
    }
  }

  // Low detail mode (no submitted form) needs to bring trailingContent up
  &.low-detail {
    position: relative;

    ${iconWrapperStyling}

    .icon-wrapper {
      top: ${rem(50)};
    }

    aside {
      order: 8;
    }
  }
`;
